import React from 'react';

const Icon = ({ className }) => (
    <svg className={className} width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.52077 11.5866L3.76943 8.83523L2.83252 9.76554L6.52077 13.4538L14.4383 5.53627L13.508 4.60596L6.52077 11.5866Z" fill="#20C655"/>
    </svg>
);

export default Icon;
